<template>
  <main v-if="loaded">
    <section-view class="header" :title="$t('conditioning.specialConditioningProject')">
      <p>
        <span>{{info.item_dict_name}}</span>
        <i></i>
      </p>
      <img class="icon" v-if="info.image_url" :src="info.image_url"/>
    </section-view>

    <text-card :title="$t('conditioning.conditioningExplanation')" :content="info.item_explain"></text-card>

    <text-card :title="$t('conditioning.conditioningCycle')" :content="info.lack_susceptibility"></text-card>

    <AlgorithmValueNotice />
    <waterfall-card
        v-if="info.show_shentizhuyaotiaolixiang.length > 0"
        :title="$t('conditioning.bodyMainConditioningItems')"
        :list="info.show_shentizhuyaotiaolixiang"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
        colorKey="color"
    ></waterfall-card>

    <waterfall-card
        v-if="info.show_yingyangsuzhuyaotiaolixiang.length > 0"
        :title="$t('conditioning.nutritionMainConditioningItems')"
        :list="info.show_yingyangsuzhuyaotiaolixiang"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
        colorKey="color"
    ></waterfall-card>

    <waterfall-card
        v-if="info.show_tigaoxiangmuduibitu && info.show_tigaoxiangmuduibitu.length > 0"
        :title="$t('conditioning.improvementProjectComparison')"
        :list="info.show_tigaoxiangmuduibitu"
        labelKey="item_dict_name"
        :valueKey="valueKey"
        legend
    ></waterfall-card>

    <!-- 详细数据报告表 -->
    <table-card :title="$t('conditioning.detailedDataReportTable')" :columns="columns" :list="info.show_xiangxishujubaogaobiao" custom></table-card>

    <!-- 特别注意 -->
    <text-card :title="$t('conditioning.specialAttention')" :content="info.nutrient_conditioning"></text-card>
  </main>
</template>

<script>
  import WaterfallCard from "@/components/WaterfallCard";
  import TableCard from "@/components/TableCard";
  import SectionView from "@/components/SectionView";
  import TextCard from "@/components/TextCard";
  import {getReportConditioningInfoH5} from "../net/api";

  export default {
    name: "Condition",
    components: {TextCard, SectionView, TableCard, WaterfallCard},

    data() {
      return {
        // 当前数据是否加载完成
        loaded: false,
        packageNo: '',
        checkcode: '',
        rand: '',
        re_id: '',

        code: '',

        // 平均值关联项
        avValueKey: {},

        // 通用态图列表数据关联项
        valueKey: {},

        columns: {},

        // 调理数据
        info: {
          item_dict_name: '',
          image_url: null,
          item_explain: '',
          lack_susceptibility: '',
          nutrient_conditioning: '',
          show_shentizhuyaotiaolixiang: [],
          show_yingyangsuzhuyaotiaolixiang: [],
          show_tigaoxiangmuduibitu: [],
          show_xiangxishujubaogaobiao: []
        }
      }
    },

    watch: {
      // 监听语言变化，重新初始化翻译文本
      '$i18n.locale'() {
        this.initTranslations();
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;
      this.re_id = query.re_id;

      this.code = query.code;

      // 初始化翻译文本
      this.initTranslations();

      this.syncPageData();
    },

    methods: {
      // 初始化翻译文本
      initTranslations() {
        // 平均值关联项
        this.avValueKey = {
          av: this.$t('conditioning.averageValue'),
        };

        // 通用态图列表数据关联项
        this.valueKey = {
          av_old: this.$t('conditioning.lastDetection'),
          av: this.$t('conditioning.currentDetection'),
        };

        this.columns = {
          item_dict_name: this.$t('conditioning.detectionItem'),
          av: this.$t('conditioning.averageValue')
        };
      },

      syncPageData() {
        getReportConditioningInfoH5({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode,
          system_code: this.code,
          re_id: this.re_id
        }).then((data) => {
          this.info = data;
          this.loaded = true;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    background-color: #D8E8FF;
    min-height: 300px;
    background-image: url("../assets/recuperate/header.png");
    background-size: 246px 274px;
    background-repeat: no-repeat;

    p {
      position: relative;
      padding: 0 10px 0 0;
      height: 70px;
      line-height: 58px;
      margin-top: 30px;
      margin-left: 50px;
      display: inline-block;

      span {
        position: relative;
        font-size: 50px;
        font-weight: 500;
        color: #333333;
        z-index: 1;
      }

      i {
        position: absolute;
        content: "";
        display: block;
        left: 0;
        width: 100%;
        height: 18px;
        background: #8DB6F2;
        border-radius: 9px;
        bottom: 5px;
      }
    }

    .icon {
      position: absolute;
      width: 220px;
      height: 220px;
      right: 10px;
      top: -36px;
      animation: fadeIn .3s;
    }
  }
</style>
